import React, { useEffect, useState } from "react";
import StripeSetupCompletedPopup from "./StripeSetupCompletedPopup";
import { useNavigate } from "react-router-dom";

export default function StripeSetupCompletedPage() {
    const [showStripePopup, setShowStripePopup] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        // open popup immediately when user lands here
        setShowStripePopup(true);
    }, []);

    return (
        <main id="main-content">
            <StripeSetupCompletedPopup />
        </main>
    );
}
